export function formatAmount(value: number | null | undefined): string {

    if (value == null || isNaN(value)) {
        return '0.00';
    }

    return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

/** 2dp string for editable money inputs — no thousands separators (parseFloat-safe). */
export function formatAmountInput(value: number | string | null | undefined): string {
    if (value == null || value === '' || isNaN(Number(value))) {
        return '';
    }
    return Number(value).toFixed(2);
}

/**
 * Comma-tolerant numeric parse. Use for EVERY read of a money model value, because
 * money inputs are formatted with thousands separators on blur and the separator
 * lands in the bound model — plain parseFloat('1,234.56') would return 1.
 */
export function parseAmount(value: number | string | null | undefined): number {
    if (value == null || value === '') {
        return 0;
    }
    const parsed = Number(String(value).replace(/,/g, ''));
    return isNaN(parsed) ? 0 : parsed;
}

/**
 * How many digit characters appear in the first `upTo` characters of `text`.
 * Used to remember a caret position independently of separator placement.
 */
export function digitsBefore(text: string, upTo: number): number {
    return (String(text).slice(0, upTo).match(/\d/g) ?? []).length;
}

/** String index just past the Nth digit of `text` — the inverse of digitsBefore. */
export function indexAfterDigits(text: string, digitCount: number): number {
    if (digitCount <= 0) {
        return 0;
    }
    let seen = 0;
    for (let i = 0; i < text.length; i++) {
        if (/\d/.test(text[i])) {
            seen++;
            if (seen === digitCount) {
                return i + 1;
            }
        }
    }
    return text.length;
}

/**
 * 2dp with thousands separators for editable money inputs. Empty string for blank
 * or non-numeric input. Idempotent — safe to call on an already-formatted value.
 */
export function formatAmountInputWithSeparators(value: number | string | null | undefined): string {
    if (value == null || value === '' || isNaN(Number(String(value).replace(/,/g, '')))) {
        return '';
    }
    return parseAmount(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
